import { updateFirestoreDoc } from "~/clients/firebase/client";

export type AuthorEditableFields =
    'rich_description' |
    'description' |
    'rich_description2' |
    'description2';

interface Props {
    data: { [key in AuthorEditableFields]?: any; }; // field to update in the author doc
    authorId: string; // doc id for the author  
    updated_by: string
}
export async function updateAuthorField({ data, authorId,updated_by }: Props): Promise<void> {
    await updateFirestoreDoc(`author_content`, authorId, {...data, updated_at: new Date(),updated_by})
}